module.exports = __webpack_public_path__ + "static/img/certificate_img31.8552bfe1.jpg";